import React, { useState, useEffect } from 'react'
import { string, node, bool } from 'prop-types'

import { Chevron } from '@assets/icons'
import * as Style from './CollapsiblePanel.style'

export default function CollapsiblePanel({ title, children, open }) {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    setIsOpen(open)
  }, [])

  const handlePanel = () => setIsOpen(!isOpen)

  return (
    <Style.Panel open={isOpen}>
      <Style.Header open={isOpen} onClick={handlePanel}>
        {title}
        <Style.Icon
          src={Chevron}
          alt="An arrow indicating that has some content below"
          open={isOpen}
          width={26}
          height={26}
        />
      </Style.Header>

      {isOpen && <Style.Body>{children}</Style.Body>}
    </Style.Panel>
  )
}

CollapsiblePanel.propTypes = {
  title: string.isRequired,
  open: bool,
  children: node.isRequired,
}

CollapsiblePanel.defaultProps = {
  open: false,
}
